/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForReportGeneration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForReportGeneration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForReportGeneration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForReportGeneration>): BackgroundJobPayloadForReportGeneration {
        let obj = Object.assign(new BackgroundJobPayloadForReportGeneration(), model);
        BackgroundJobPayloadForReportGeneration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForReportGeneration>): BackgroundJobPayloadForReportGeneration {
        if (!model) return null;
        return BackgroundJobPayloadForReportGeneration.newInstance(<BackgroundJobPayloadForReportGeneration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForReportGeneration) {
        if (!obj) return;

        models.BackgroundJobPayloadForReportGeneration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForReportGeneration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForReportGeneration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.report_options) {
            models.ReportGenerationOptions.fixupPrototype(this.report_options);
        }
    }

    /**
     * HTML content of report
     */
    html: string;

    report_options: models.ReportGenerationOptions;

}
